import { Card, CardContent, CardHeader, CardTitle } from "../../../client/components/ui/card";
import useTranslation from "../../../client/hooks/useTranslation";
import type { ReportMetrics } from "../../metrics/types";
import { formatCurrency, pnlTextClass } from "./formatValue";

function formatRoi(roi: number): string {
  const sign = roi > 0 ? "+" : "";
  return `${sign}${roi.toFixed(1)} %`;
}

/** Bilan financier prop firm de la période : dépensé, reçu en payouts, net et
 *  ROI net. Mêmes chiffres que la barre KPI du Prop Firm Manager. Retourne null
 *  pour un snapshot antérieur à ce champ ou un périmètre sans compte. */
export function PropFirmFinanceSection({ metrics }: { metrics: ReportMetrics }) {
  const t = useTranslation();
  const finance = metrics.propFirmFinance;
  if (!finance) return null;

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-base">{t.reports.financeTitle}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          <div>
            <div className="text-xs text-muted-foreground">{t.reports.financeSpent}</div>
            <div className="text-xl font-mono font-semibold text-foreground">
              {formatCurrency(finance.spent, metrics.currency)}
            </div>
          </div>

          <div>
            <div className="text-xs text-muted-foreground">{t.reports.financePayouts}</div>
            <div className="text-xl font-mono font-semibold text-foreground">
              {formatCurrency(finance.payouts, metrics.currency)}
            </div>
          </div>

          <div>
            <div className="text-xs text-muted-foreground">{t.reports.financeNet}</div>
            <div className={`text-xl font-mono font-semibold ${pnlTextClass(finance.net)}`}>
              {formatCurrency(finance.net, metrics.currency)}
            </div>
          </div>

          <div>
            <div className="text-xs text-muted-foreground">{t.reports.financeRoi}</div>
            {finance.roi === null ? (
              <div className="text-sm text-muted-foreground mt-1">{t.reports.financeRoiNone}</div>
            ) : (
              <div className={`text-xl font-mono font-semibold ${pnlTextClass(finance.roi)}`}>
                {formatRoi(finance.roi)}
              </div>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
